import { mapActions } from 'vuex';
import { interactionObserverMixin } from '@dreipol/vue-ui';

export default {
    mixins: [interactionObserverMixin],
    props: {
        isMain: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        ...mapActions('navigation', ['setNavVisibility']),

        onIntersectEnter() {
            this.setNavVisibility({ isVisible: true });
        },

        onIntersectLeave() {
            this.setNavVisibility({ isVisible: false });
        },
    },
};
